import React from "react";
import { ThemeContext } from "../../ContextProvider/ThemeContext";
import WindowSize from "../../Utils/WindowSize";
import styles from "./About.module.css";

const About = () => {
  const { newTheme } = React.useContext(ThemeContext);
  const [width] = WindowSize();

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "50px" }}>
      <div
        className={styles.container}
        style={{ boxShadow: `3px 3px 5px ${newTheme.line}` }}
      >
        <div className={styles.first}>
          <img
            src={
              // "https://github.com/Swapnil1296/portfolio_images/blob/main/images/developer.gif?raw=true"
              "https://i0.wp.com/www.inventiva.co.in/wp-content/uploads/2021/02/download.jpg"
              // "https://www.linkpicture.com/q/profilePhoto_2.jpg"
            }
            alt=""
          />
        </div>
        <div className={styles.second}>
          <h1 style={{ color: `${newTheme.title}` }} className={styles.heading}>
            About Me
          </h1>
          <div className={styles.borderBottom} />
          <p style={{ color: `${newTheme.para}` }} className={styles.aboutMe}>
            Hello! Myself Sunil Sahu and I enjoy creating things that live on
            the internet.
            <br />
            Enjoys working on dynamic web projects and writing easy-to-read
            code. <br />
            <br /> Fast Forwarding to today, I built several web applications
            and major projects. Learned a great deal about teamwork, leadership,
            and communication. After months of rigorous experiences,
            <span style={{ color: `#00a0a0` }}>
              {" "}
              I’m currently open for a new job opportunity.
              <br />
            </span>
            <br />
            Apart from coding, some other activities that I love to do!
            <ul>
              <li className="about-activity">Reading books</li>
              <li className="about-activity">Riding</li>
              <li className="about-activity">Badminton</li>
              <li className="about-activity">Watering plants</li>
            </ul>
          </p>
        </div>
      </div>
      <div>
        <p
          style={{
            display: "flex",
            justifyContent: "center",
            color: `${newTheme.title}`,
            fontSize: "30px",
            // border: "2px solid green",
          }}
        >
          Work Experience
        </p>
        <div className={styles.borderBottom} style={{ marginTop: "-20px" }} />
      </div>

      <div
        className={styles.container}
        style={{
          border: "1px solid gray",
          boxShadow: `3px 3px 5px ${newTheme.line}`,
        }}
      >
        <div className={styles.second} style={{ textAlign: "center" }}>
          <div
            style={{ color: "#00a0a0", fontSize: "25px" }}
            // className={styles.aboutMe}
          >
            <p style={{}}>Full-Stack Web Developer (MERN)</p>
            <a
              href="https://www.searchingyard.com/"
              target="_blank"
              rel="noreferrer"
            >
              <p
                style={{
                  cursor: "pointer",
                  textDecoration: "underline",
                  marginTop: "-10px",
                }}
              >
                Searchingyard Software Pvt. Ltd.
              </p>
            </a>
            <p
              style={{
                marginTop: "-10px",
              }}
            >
              2023-2024 (1year+) Bhubaneswar
            </p>
          </div>
          <div
            style={{
              color: "gray",
              width: "95%",
              // textAlign: "start",
              lineHeight: "28px",
              textAlign: "center",
              marginLeft: "5px",

              // border: "2px solid yellow",
            }}
          >
            Experienced full-stack developer in e-commerce and education.
            Proficient in project lifecycle, using Tailwind CSS, Next.js,
            Node.js, Express.js, MongoDB, Firebase, and AWS.
          </div>
          <div
            style={{
              color: "gray",
              width: "95%",
              // textAlign: "start",
              // lineHeight: "28px",
              textAlign: "center",
              marginTop: "30px",

              // border: "2px solid yellow",
            }}
          >
            <a
              href="https://github.com/sunilbrown89"
              rel="noopener noreferrer"
              target="_blank"
            >
              <i className="fab fa-github" style={{ fontSize: "50px" }} />
            </a>
          </div>
        </div>

        <div className={styles.second}>
          <h1
            style={{
              color: "gray",
              display: "flex",
              justifyContent: "center",
              // color: `${newTheme.title}`,
              fontSize: "20px",
              fontWeight: "normal",
            }}
            // className={styles.heading}
          >
            Achievements/Tasks
          </h1>
          <div
            style={{
              color: `${newTheme.para}`,
              justifyContent: "start",
              lineHeight: "28px",
            }}
            className={styles.aboutMe}
          >
            <p>
              Developed a cutting-edge event lead page tool, handling both
              front-end and back- end aspects, utilized by over 80+prestigious
              universities. Leveraging Next.js, Redux, Node.js, MongoDB,
              Express.js, Firebase, and Tailwind CSS, it has streamlined
              registration processes with over 2000+ event registrations to
              date, enhancing attendee engagement.
              <br /> <br />
              <br /> Managed and mentored 10+ team members, facilitating their
              development and ensuring their efficient assimilation into the
              team. Additionally, assumed responsibility for all project
              developments in the Arab region, ensuring successful execution and
              alignment with organizational objectives.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
